import { render, staticRenderFns } from "./ProjectsNew.vue?vue&type=template&id=7ab16aa8&scoped=true"
import script from "./ProjectsNew.vue?vue&type=script&lang=ts"
export * from "./ProjectsNew.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsNew.vue?vue&type=style&index=0&id=7ab16aa8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab16aa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ab16aa8')) {
      api.createRecord('7ab16aa8', component.options)
    } else {
      api.reload('7ab16aa8', component.options)
    }
    module.hot.accept("./ProjectsNew.vue?vue&type=template&id=7ab16aa8&scoped=true", function () {
      api.rerender('7ab16aa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/managerDetails/ProjectsNew.vue"
export default component.exports